import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
//import Demand from '../../../Models/Banque';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";

import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import User from "../ManageUser/User";
//import Banque from "../../../Models/Banque";
import SearchModalMUI from "../../SearchModalMUI";
import SelectOptionMUI from "../../SelectOptionMUI";
import InputFormMUI from "../../InputTMUI";
import {IParametreBDC} from "../../../dataTypes/GlobalDataType";


const ParamBDC = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Idlibell, setIdlibell] = useState(true);
    const [DataBranch, SetDataBranch] = useState<IParametreBDC[]>([]);
    const [currentDataBranch, setCurrentDataBranch] = useState<IParametreBDC | null>(null);
      
     const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(0); // Page actuelle
     const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
     const [error, setError] = useState<string | null>(null);
          const [loading2, setLoading2] = useState(false);
       
    //const [billetages, setBilletages] = useState<Lib[]>([]);
   
   const dataOption2: DataSelect[] = [
  { label: "BDC--BON DE CAISSE", value: "BDC" },
  { label: "DAT--DEPOT A TERME", value: "DAT" }
]

  const dataOption3: DataSelect[] = [
  { label: "PRE--BON DE CAISSE PRECOMPTE", value: "PRE" },
  { label: "POST--BON DE CAISSE PRECOMPTE", value: "POST" }
]

    //pour les agences
let searchBDC: ParamsPicklist = { CodeAgence: Perss.codage, Table: "PARAMDBC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: 'CODAGE', Choix: 1 }
let searchFreq: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'PERIOD', Choix: 22 }

//pour les Comptes
let searchVille: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'PERIOD', Choix: 22 }

//pour les COMPTES
let searchComptes: ParamsPicklist = { CodeAgence: Perss.codage, Table: "Comptes", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'AGCCPT', Choix: 22 }

//let searchRegion: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'REGION', Choix: 22  }

useEffect(() => {
    loadAllDataBranch();
}, []);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        setIdbutton(true)
    }

    function HandleAjout() {
        HandleAnnul();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdlibell(false);
        
    }

    function HandleModif() {
        setAjoute(true)
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        setIdbutton(true);
        setIdlibell(false);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdlibell(true);
        setIdbutton(false)
    }
  // 📄 Filtrage des données en fonction du terme de recherche
  const filteredDataBranch = DataBranch.filter((item) =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  // 📄 Pagination après filtrage
  const paginatedDataBranch = filteredDataBranch.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
// --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
  const handleOpenDialog = (DataToEdit: IParametreBDC | null = null) => {
    if (DataToEdit) {
      setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
      form.setFieldsValue({...DataToEdit})
      HandleModif()
     // console.log(DataToEdit)
    } else {
      // Initialiser un nouvel objet avec des valeurs par défaut
      setCurrentDataBranch({
    CODBDC:	"string",
    LIBELL:	"string",
    CODAGE:	"string",
    DATCRE:	Perss.datjour,
    UTISAI:	"string",
    TYPBDC:	"string",
     TYPIMPUTINT:	"string",
    FREQPROV:	"string",
    DUREE:	0,
    CPTINT:	"string",
    CPTPROV:	"string",
    LIBINTDEB:	"string",
    //LIBINTCRE:	"string",
    //LIBPROVDEB:	"string",
    LIBPROVCRE:	"string",
    CPTTAXEDEB:	"string",
    CPTTAXECRE:	"string",
    LIBTAXEDEB:	"string",
    LIBTAXECRE:	"string",
    TXINT :	0,
    TXTAXE :	0,
    TXPENALITE :	0,
    CPTPENALITE :	"string",
    LIBPENALITE :	"string",
     CPTTAXEPENALITE :	"string",
    LIBTAXEPENALITE :	"string",
      });
    }
   // setOpenDialog(true);
   // setDialogError(null); // Réinitialiser les erreurs du dialogue
  };

 
    async function loadAllDataBranch() {
      
         setLoading2(true);
        setError(null);
        try {
     // console.log(apiEndpoints.bureaux)
      var params = { CodeAgence: Perss.codage , Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }

      const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
     if (data.length!==0)
         {
    // alter(data.result)
      console.log(data)
      SetDataBranch(data); // ou console.log(data)
         }
      }catch (err) {
      console.error("Erreur de chargement:", err);
      setError("Impossible de charger les données .");
     } finally {
      setLoading2(false);
     }
    }
// 🔁 Gestion du changement de page
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // 🔁 Gestion du changement de nombre de lignes
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Revenir à la première page après changement
  };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Type bon de caisse
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1}}>
                            <legend> Pramètres bon de caisse </legend>

                            {/* Ligne 1 : Inputs d'information */}
                              <Grid container spacing={2}>
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={Idlibell} width={250} Titre="Recherche" label='Code' name="CODBDC" Parametre={searchBDC}  form={form}/>
                                 </Grid>
                                  <Grid item xs={3}> 
                                    <SelectOptionMUI form={form} disabled={false} Size='small' name="TYPBDC" Option={dataOption2} label="Type de bon"/>           
                                   </Grid>

                                   <Grid item xs={3}> 
                                    <SelectOptionMUI form={form} disabled={false} Size='small' name="TYPIMPUTINT" Option={dataOption3} label="Type imputation"/>           
                                   </Grid>             
                              </Grid>

                               <Grid container spacing={2}>
                                <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={250} Titre="Recherche" label='Fréquence' name="FREQPROV" Parametre={searchFreq}  form={form}/>
                                 </Grid>
                                 <Grid item xs={1.5} >
                                 <InputFormMUI   label="Durée" name='DUREE'  type='number' />
                                  </Grid>   
                                  <Grid item xs={1.5} >
                                 <InputFormMUI   label="Taux interêt" name='TXINT'  type='number' />
                                  </Grid>  
                                   <Grid item xs={1.5} >
                                 <InputFormMUI   label="Taux penalité" name='TXPENALITE'  type='number' />
                                  </Grid>  

                                  <Grid item xs={1.5} >
                                 <InputFormMUI   label="Taux taxe" name='TXTAXE'  type='number' />
                                  </Grid>    
                               </Grid>

                               {/* Ligne 1 : Inputs d'information */}
                              <Grid container spacing={2}>
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte interêt' name="CPTINT" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                  <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé débit interêt" name='LIBINTDEB'  type='text' />
                                  </Grid>  

                                     {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé crédit interêt" name='LIBINTCRE'  type='text' />
                                  </Grid>    */}
                                 
                                                                           
                                           
                              </Grid>
                              <Grid container spacing={2}>
                                   
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte provision' name="CPTPROV" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                 {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé provision débit" name='LIBPROVDEB'  type='text' />
                                  </Grid>        */}

                                  <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé provision crédit" name='LIBPROVCRE'  type='text' />
                                  </Grid>    

                              </Grid>

                            <Grid container spacing={2}>
                                   
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte taxe débit' name="CPTTAXEDEB" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                 <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé taxe débit" name='LIBTAXEDEB'  type='text' />
                                  </Grid>       

                                  {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé taxe crédit" name='LIBTAXECRE'  type='text' />
                                  </Grid>     */}

                              </Grid>

                              
                            <Grid container spacing={2}>
                                   
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte taxe crédit' name="CPTTAXECRE" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                 <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé taxe crédit" name='LIBTAXECRE'  type='text' />
                                  </Grid>       

                                  {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé taxe crédit" name='LIBTAXECRE'  type='text' />
                                  </Grid>     */}

                              </Grid>
                               
                               <Grid container spacing={2}>
                                   
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte penalite' name="CPTPENALITE" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                 <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé penalite" name='LIBPENALITE'  type='text' />
                                  </Grid>       

                                  {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé taxe crédit" name='LIBTAXECRE'  type='text' />
                                  </Grid>     */}

                              </Grid>

                              <Grid container spacing={2}>
                                   
                                 <Grid item xs={6}>
                                  <SearchModalMUI notremove disabledCode={Idlibell} disabledLibell={true} width={300} Titre="Recherche" label='Compte taxe/penalite' name="CPTTAXEPENALITE" Parametre={searchComptes}  form={form}/>
                                 </Grid>
                                 <Grid item xs={6} >
                                 <InputFormMUI   label="Libellé taxe/penalite" name='LIBTAXEPENALITE'  type='text' />
                                  </Grid>       

                                  {/* <Grid item xs={3} >
                                 <InputFormMUI   label="Libellé taxe crédit" name='LIBTAXECRE'  type='text' />
                                  </Grid>     */}

                              </Grid>
                       

                               <Box style={{ width: '100%' }}>
                                    <fieldset className="bordure1"  >
                                        {/* Zone de recherche */}
                                              <Box sx={{ mb: 2 }}>
                                                <TextField
                                                  label="Recherche"
                                                  variant="outlined"
                                                  fullWidth
                                                  
                                                  value={searchTerm}
                                                   onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(0); // Remettre à la page 0 après recherche
                                                  }}
                                                  size="small"
                                                  InputLabelProps={{
                                                      sx: {
                                                        fontWeight: 'bold',
                                                              },
                                                             }}
                                                  InputProps={{
                                                     endAdornment: (
                                                     <InputAdornment position="end">
                                                     <SearchIcon color="action" />
                                                     </InputAdornment>
                                                                 ),
                                                             }}
                                                />
                                               
                                              </Box>
                                              
                                         <TableContainer component={Paper} elevation={3} sx={{
                                              // --- Styles pour les ascenseurs ---
                                              maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                                              overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                                              overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                                              width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                                              minWidth: '800', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                                            }}>
                                                
                                            <Table stickyHeader size="small" >
                                              <TableHead  >
                                                <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Code </TableCell>
                                                 
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Libellé</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Fréquence</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Durée</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>comppte interet</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>comppte provision</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée le</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée par</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Actions</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {paginatedDataBranch.length === 0 ? (
                                                  <TableRow>
                                                    <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                                                  </TableRow>
                                                ) : (
                                                  paginatedDataBranch.map((item,index) => (
                                                    <TableRow   key={`${item.CODBDC}-${item.LIBELL}-${item.CODAGE}`}  sx={{
                                                     cursor: 'pointer',
                                                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                                     '&:hover': {
                                                      // backgroundColor: '#e0f7fa', // Couleur au survol
                                                     // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                                      //color: '#fff', // Texte blanc sur fond sombre
                                                      background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                        },
                                                             }} > 
                                                     {/* Clé unique pour React */}
                                                      <TableCell sx={{ py: 0 }}>{item.CODBDC}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.LIBELL}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.FREQPROV}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.DUREE}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.CPTINT}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.CPTPROV}</TableCell>
                                                      <TableCell sx={{ py: 0 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.UTISAI ?? 'N/A'}</TableCell>
                                                     
                                                      <TableCell sx={{ py: 0 }}>
                                                        <IconButton color="primary" onClick={() => handleOpenDialog(item)}>
                                                          <EditIcon />
                                                        </IconButton>
                                                        <IconButton color="error" onClick={() => HandleSupp()}>
                                                          <DeleteIcon />
                                                        </IconButton>
                                                      </TableCell>
                                                    </TableRow>
                                                  ))
                                                )}
                                              </TableBody>
                                            </Table>
                                        </TableContainer>
                                         {/* Pagination */}
                                              <TablePagination
                                                component="div"
                                                count={filteredDataBranch.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                labelRowsPerPage="Lignes par page"
                                              />
                                    </fieldset>
                                 </Box>
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];

    // function consult 
    function consult() {
        loadAllDataBranch();
     
    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: IParametreBDC = values

       // Demand.NUMCPT = Demand.NUMBAN
        Demand.DATCRE = formatDate(Perss.datjour)
        //Demand.DATMAJ = formatDate(Perss.datjour)
        Demand.LIBELL = form.getFieldValue("lib_CODBDC")
        Demand.CODAGE = Perss.codage
        Demand.UTISAI = Perss.coduti

      //  alert(Demand.DATMAJ)
     console.log(Demand)

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un type de bon de caisse",
                text: "Voulez-vous Créer le type de bon de caisse : " + form.getFieldValue("lib_CODBDC"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateParamBDC,
                        headers: {
                            'CypherParamBDC': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result
                                //console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Mise à jour type bon de caisse",
                text: "Voulez-vous Mettre à jour La Banque' : " + form.getFieldValue("LIBELL"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateParamBDC,
                        headers: {
                            'CypherBank': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'un type de bon de caisse",
                text: "Voulez-vous Supprimer la Banque :" + form.getFieldValue("LIBELL"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.CODBDC));
                    let data2 = Crypter.encrypt(JSON.stringify(Demand.CODAGE));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteParamBDC,
                        headers: {
                            'CypherParamBDC': data,
                            'CypherAgence': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult(); }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button> */}
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default ParamBDC;